import { useMemo, useState } from 'react';
import { useCaApiSdk } from '../../api-sdk/context/use-ca-api-sdk';
import { CaOrganizationContext } from './ca-organization-context';
import { CaOrganization, Organization } from './types';

export const CaOrganizationProvider: React.FC<React.PropsWithChildren> = (props) => {
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [organization, setOrganization] = useState<Organization>(null);

  const sdk = useCaApiSdk();

  const { isLoading } = sdk.useOrganization(
    organizationId,
    {
      id: organizationId as string,
    },
    {
      onSuccess: (response) => {
        const organization: CaOrganization = response?.getOrganization;
        if (organization) {
          setOrganization({
            id: organization.id,
            name: organization.name,
            urlSlug: organization.alias,
            type: organization.type,
          });
        }
      },
    },
  );

  const memoizedValue = useMemo(() => {
    return { organization, setOrganizationId, isLoading };
  }, [organization, setOrganizationId, isLoading]);

  return <CaOrganizationContext.Provider {...props} value={memoizedValue} />;
};
